import React, { FC, HTMLAttributes } from 'react'

import { ImageResponsive } from '@/types/common'
import { useResponsiveImage } from '@/utils/hooks'

type ImageByWidthDevice = { images: ImageResponsive; alt: string } & HTMLAttributes<HTMLImageElement>
const ImageByWidthDevice: FC<ImageByWidthDevice> = ({ images, alt, ...rest }) => {
  const imageUrl = useResponsiveImage(images)
  return (
    <img
      {...rest}
      alt={alt}
      src={imageUrl}
      loading='lazy'
    />
  )
}

export default ImageByWidthDevice
